import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { IconRefresh } from '@assets/icons';
import { useCurrentOrchestrator } from '@domains/orchestrator-pricing-committee/hooks/useCurrentOrchestrator';

export const RefreshOrchestratorButton = () => {
  const { currentOrchestrator } = useCurrentOrchestrator();
  const { refetch } = currentOrchestrator;

  const handleClick = () => {
    if (typeof refetch === 'function') {
      refetch();
    }
  };

  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="tooltip-refresh">Actualizar</Tooltip>}
    >
      <Button
        className="p-0"
        size="sm"
        onClick={handleClick}
        variant="link"
        data-testid="refresh-orchestrator-button"
      >
        <IconRefresh fill={'rgb(108, 117, 125)'} />
      </Button>
    </OverlayTrigger>
  );
};
